module.exports = __webpack_public_path__ + "static/img/google_fit.236dc6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/brand/health/assets/google_fit.png
// module id = xJoU
// module chunks = 1